export default {
	home: {
		afunOriginals: "AFun मूल",
		slots: "स्लॉट्स",
		liveCasino: "लाइव कैसीनो",
		casualGames: "कैज़ुअल गेम्स",
		newReleases: "नई रिलीज़",
		casinoTitle: "कैसीनो",
		casinoDesc: "हजारों स्लॉट्स, लाइव डीलर्स और टेबल गेम्स के साथ कैसीनो गेम्स का आनंद लें",
		goToCasino: "कैसीनो पर जाएं",
		sportsTitle: "खेल",
		sportsDesc: "फुटबॉल, बास्केटबॉल, टेनिस और अधिक खेलों पर सर्वोत्तम ऑड्स के साथ दांव लगाएं",
		goToSports: "खेल पर जाएं",
		liveTitle: "लाइव",
		liveDesc: "लाइव डीलर्स और इंटरैक्टिव गेमिंग अनुभव के साथ रियल-टाइम एक्शन",
		goToLive: "लाइव पर जाएं",
		latestBetRace: "नवीनतम दांव और रेस",
		sports: "खेल",
		latestBets: "नवीनतम दांव",
		game: "गेम",
		player: "खिलाड़ी",
		bet: "दांव",
		multiplier: "गुणक",
		profit: "लाभ",
		top10Games: "शीर्ष 10 गेम्स",
		vip: "VIP",
		rewards: "पुरस्कार",
		affiliate: "सहबद्ध",
		promotion: "प्रचार"
	},

	latestBetRace: {
		title: "गेम लीडरबोर्ड ग्रैंड प्रिक्स",
		playerBetRank: "आज के खिलाड़ी दांव",
		playerWinRank: "आज के खिलाड़ी जीत",
		gameBetRank: "आज के गेम दांव",
		gameWinRank: "आज के गेम रिटर्न",
		player: "खिलाड़ी",
		game: "गेम",
		bet: "दांव",
		profit: "जीत",
		ratio: "पेआउट अनुपात",
		totalBet: "कुल दांव",
		totalReturn: "कुल रिटर्न",
		maxBet: "अधिकतम दांव",
		gameRatio: "रिटर्न %",
		noData: "कोई डेटा उपलब्ध नहीं",
	},

	GameClassify: {
		casinoTitle: "कैसीनो",
		casinoDesc: "शीर्ष प्रदाताओं से कैसीनो खेलों का आनंद लें",
		casinoBtn: "कैसीनो पर जाएं",
		sportsTitle: "खेल",
		sportsDesc: "फुटबॉल, क्रिकेट, NFL, ई-स्पोर्ट्स और 80 से अधिक खेलों पर दांव लगाएं",
		sportsBtn: "खेल पर जाएं",
		liveTitle: "लाइव",
		liveDesc: "लाइव डीलरों के साथ वास्तविक समय का अनुभव",
		liveBtn: "लाइव पर जाएं"
	}
}